document.documentElement.classList.add('js');

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (!toggle) return;
  const header = toggle.closest('.site-header');
  const open = header.classList.toggle('menu-open');
  toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
});

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const form = select.closest('form');
  const selected = select.options[select.selectedIndex];
  const id = form.querySelector('[name="id"]');
  const button = form.querySelector('[type="submit"]');
  if (id) id.value = selected.value;
  const product = select.closest('.product-page');
  const price = product?.querySelector('[data-product-price]');
  const compare = product?.querySelector('[data-product-compare]');
  if (price) price.textContent = selected.dataset.price;
  if (compare) { compare.textContent = selected.dataset.compare || ''; compare.hidden = !selected.dataset.compare; }
  if (button) {
    button.disabled = selected.dataset.available !== 'true';
    button.textContent = selected.dataset.available === 'true' ? 'Add to bag' : 'Sold out';
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.site-header.menu-open').forEach((header) => {
    header.classList.remove('menu-open');
    const toggle = header.querySelector('[data-menu-toggle]');
    if (toggle) { toggle.setAttribute('aria-expanded', 'false'); toggle.focus(); }
  });
});


// Consent is recorded only after a visitor chooses an option.
(() => {
  const dialog = document.getElementById('CookiePreferences');
  if (!dialog) return;
  const status = dialog.querySelector('.cookie-status');
  const actionButtons = [...dialog.querySelectorAll('[data-consent-action]')];
  const optOut = dialog.querySelector('[data-sale-opt-out]');
  let api;
  let trigger;
  function loadPrivacy() {
    if (window.Shopify?.customerPrivacy) return Promise.resolve(window.Shopify.customerPrivacy);
    return new Promise((resolve, reject) => {
      if (!window.Shopify?.loadFeatures) return reject(new Error('Unavailable'));
      const timeout = setTimeout(() => reject(new Error('Timed out')), 10000);
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], (error) => {
        clearTimeout(timeout);
        if (error || !window.Shopify.customerPrivacy) reject(error || new Error('Unavailable'));
        else resolve(window.Shopify.customerPrivacy);
      });
    });
  }
  document.addEventListener('click', async (event) => {
    const opener = event.target.closest('[data-cookie-preferences]');
    if (!opener) return;
    trigger = opener;
    dialog.showModal();
    status.textContent = 'Loading your choices…';
    actionButtons.forEach(button => { button.disabled = true; });
    optOut.hidden = true;
    try {
      api = await loadPrivacy();
      const consent = api.currentVisitorConsent();
      dialog.querySelectorAll('[data-consent-category]').forEach(input => { input.checked = consent[input.dataset.consentCategory] === 'yes'; });
      optOut.hidden = !api.saleOfDataRegion();
      status.textContent = '';
      actionButtons.forEach(button => { button.disabled = false; });
    } catch (_) {
      status.textContent = 'Your cookie choices could not be loaded. Please try again, or contact info@essentialdesignslondon.co.uk.';
    }
  });
  dialog.addEventListener('click', event => {
    const button = event.target.closest('[data-consent-action], [data-sale-opt-out]');
    if (!button || !api) return;
    const isOptOut = button.hasAttribute('data-sale-opt-out');
    const consent = {};
    if (isOptOut) consent.sale_of_data = false;
    else dialog.querySelectorAll('[data-consent-category]').forEach(input => {
      consent[input.dataset.consentCategory] = button.dataset.consentAction === 'accept' ? true : button.dataset.consentAction === 'reject' ? false : input.checked;
    });
    actionButtons.forEach(item => { item.disabled = true; });
    optOut.disabled = true;
    status.textContent = 'Saving your choices…';
    const timeout = setTimeout(() => {
      status.textContent = 'Your choices could not be confirmed. Please try again.';
      actionButtons.forEach(item => { item.disabled = false; });
      optOut.disabled = false;
    }, 10000);
    try {
      api.setTrackingConsent(consent, () => {
        clearTimeout(timeout);
        status.textContent = isOptOut ? 'Your data sale and sharing opt-out has been saved.' : 'Your cookie choices have been saved.';
        actionButtons.forEach(item => { item.disabled = false; });
        optOut.disabled = false;
      });
    } catch (_) {
      clearTimeout(timeout);
      status.textContent = 'Your choices could not be saved. Please try again.';
      actionButtons.forEach(item => { item.disabled = false; });
      optOut.disabled = false;
    }
  });
  dialog.addEventListener('close', () => trigger?.focus());
})();
